/**
 * Detect actual input modality (mouse/trackpad vs touch vs pen) via
 * PointerEvent.pointerType — updated live as the user switches devices.
 *
 * Also detects if the browser uses "classic" scrollbars (which occupy layout space)
 * and sets `--tb-scrollbar-width` accordingly, adding `.has-classic-scrollbars`.
 */

export type PointerInputType = 'mouse' | 'touch' | 'pen' | ''

let currentPointerType: PointerInputType = ''

export function getPointerInputType (): PointerInputType {
  return currentPointerType
}

// function applyClasses (type: PointerInputType): void {
//   const root = document.documentElement
//   root.classList.toggle('input-env-mouse-like', type === 'mouse')
//   root.classList.toggle('input-env-touch-like', type === 'touch' || type === 'pen')
// }

export function measureScrollbarWidth (): void {
  // Create a hidden container with forced scrollbars
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll'
  outer.style.position = 'absolute'
  outer.style.top = '-9999px'
  outer.style.width = '100px'
  outer.style.height = '100px'
  document.body.appendChild(outer)

  const inner = document.createElement('div')
  inner.style.width = '100%'
  inner.style.height = '200px'
  outer.appendChild(inner)

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth
  outer.parentNode?.removeChild(outer)

  const root = document.documentElement
  root.style.setProperty('--tb-scrollbar-width', `${scrollbarWidth}px`)
  root.classList.toggle('has-classic-scrollbars', scrollbarWidth > 0)
}

/**
 * Listens to pointerdown / pointermove and toggles
 * `input-env-mouse-like` / `input-env-touch-like` on `<html>`
 * whenever the user switches input device.
 */
export function initPointerInputEnv (): void {
  // Measure classic scrollbar width on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureScrollbarWidth)
  } else {
    measureScrollbarWidth()
  }

  // function update (e: PointerEvent): void {
  //   const type = e.pointerType as PointerInputType
  //   if (type === currentPointerType) return
  //   currentPointerType = type
  //   applyClasses(type)
  // }

  document.addEventListener('pointerdown', measureScrollbarWidth, true)
  document.addEventListener('pointermove', measureScrollbarWidth, true)
}

